import React, { useEffect } from 'react';
import PillarCard from './PillarCard';

import { fireTag } from '../../libs/analytics';


const PillarScrollers = ({isMobile, enableScrollGA}) => {

	let scrollHousing = false;
	let scrollSustainability = false;
	let scrollSmallBiz = false;
	let scrollFinancialHealth = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(!window.location.href.includes('/sustainability/') && 
			!window.location.href.includes('/housing/') && !window.location.href.includes('/map/') 
			&& !scrollHousing && document.querySelector('#housing').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollHousing = true;
				fireTag('S1');
			}
			// if(!window.location.href.includes('/sustainability/') && 
			// !window.location.href.includes('/housing/') && !window.location.href.includes('/map/') 
			// && !scrollSustainability && document.querySelector('#sustainability').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
			// 	scrollSustainability = true;
			// 	fireTag('S2');
			// }
			if(!window.location.href.includes('/sustainability/') && 
			!window.location.href.includes('/housing/') && !window.location.href.includes('/map/') 
			&& !scrollSmallBiz && document.querySelector('#small-biz').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollSmallBiz = true;
				fireTag('S3');
			}
			if(!window.location.href.includes('/sustainability/') && 
			!window.location.href.includes('/housing/') && !window.location.href.includes('/map/') 
			&& !scrollFinancialHealth && document.querySelector('#financial-health').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollFinancialHealth = true;
				fireTag('S4');
			}
		});
	},[])

	return (
		<div id="tab-slide-ups">
			<PillarCard id="tab-1" cardNum={1} isMobile={isMobile} enableScrollGA={enableScrollGA}/>
			<PillarCard id="tab-3" cardNum={2} isMobile={isMobile} enableScrollGA={enableScrollGA}/>
			<PillarCard id="tab-4" cardNum={3} isMobile={isMobile} enableScrollGA={enableScrollGA}/>
		</div>
	);

};

export default PillarScrollers;
